module.exports = "<md-button class=\"md-icon-button\" ng-click=\"nav.toggleSidenav()\" hide-gt-md>\r\n    <md-icon class=\"material-icons\">menu</md-icon>\r\n</md-button>";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarMenu.html
 ** module id = 294
 ** module chunks = 0
 **/